import { get, post, put, uploadFile } from './client.js';
import type {
  WebsiteRebuildResponse,
  WebsiteRebuildStatusEnvelope,
  WebsitePreflight,
} from '../types/index.js';

export const websiteApi = {
  rebuild: () => post<WebsiteRebuildResponse>('/website/rebuild'),
  status: () => get<WebsiteRebuildStatusEnvelope>('/website/rebuild/status'),
  preflight: () => get<WebsitePreflight>('/website/rebuild/preflight'),
  aboutAdmin: () => get<{ published: Record<string, unknown>; draft: Record<string, unknown> }>('/website/about/admin'),
  saveAboutDraft: (content: Record<string, unknown>) => put<{ published: Record<string, unknown>; draft: Record<string, unknown> }>('/website/about/admin', { content }),
  publishAbout: (content?: Record<string, unknown>) => post<{ content: Record<string, unknown> }>('/website/about/publish', content ? { content } : undefined),
};

export function uploadAboutImage(file: File, onProgress?: (percent: number) => void): Promise<{ filename: string; url: string }> {
  const formData = new FormData();
  formData.append('file', file);
  return uploadFile('/website/about/upload-image', formData, onProgress);
}
